import React from 'react'

export default function Container({ children, style }) {
    return (
        <div className={ `input-container` } style={style}>
            { children }
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Form/Container.js